import { CoreMyLeagueTableView } from '../../../../../core/views';
import EmptyCompRow from '../EmptyCompRow';
import CompRowView from '../CompRow';

/**
 * @desc Comps My View Class
 * This class using on leagues my page ('fantasy/leagues')
 */
export default class MyCompsTableView extends CoreMyLeagueTableView {
	get className() {
		return "my-leagues-table";
	}

	get emptyView() {
		return EmptyCompRow;
	}

	get childView() {
		return CompRowView;
	}

	get childViewOptions() {
		return {
			...super.childViewOptions,
			rounds: this.rounds
		}
	}
}